// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"3fe9acf6","499":"8f142de7","555":"64dbec00","742":"6d39b7b2","818":"a8918013","936":"9258e77e","953":"1e92c11d"}[chunkId] + ".chunk.js";
};